import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { map } from 'rxjs/operators';

import { Profile } from '../_models/profile.model';
import { Procedure } from '../_models/procedure.model';
import { User } from '../_models/user.model';
import { EnvironmentService } from './environment.service';

@Injectable()
export class ProfileService {
  profiles: Profile[];
  selectedProfile: Profile;
  profilesSubject: Subject<Profile[]> = new Subject<Profile[]>();
  selectedProfileSubject: Subject<Profile> = new Subject<Profile>();

  constructor(private http: HttpClient,
              private environmentService: EnvironmentService) {
    this.profiles = [];
  }

  getProfiles() {
    const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.authToken) {
      const options = {
        headers: new HttpHeaders().append('Authorization', `Bearer ${currentUser.authToken}`)
      };
      return this.http
        .post(`${this.environmentService.apiUrl}/profiles`, currentUser.userAccessProfile)
        .pipe(
          map((profiles: Profile[]) => {
            this.profiles = profiles;
            return profiles;
          })
        );
    }
  }

  getSelectedProfile() {
    return this.selectedProfile;
  }

  setSelectedProfile(id: number) {
    if (id > -1) {
      this.selectedProfile = this.profiles.find((profile: Profile) => {
        return profile.counter === id;
      });
      this.selectedProfileSubject.next(this.selectedProfile);
    } else {
      this.selectedProfile = null;
      this.selectedProfileSubject.next(null);
    }
  }

  getProfileProcedure(id: number) {
    return this.selectedProfile.procedures.find((procedure: Procedure) => {
      return procedure.proc_id === id;
    });
  }

  getProfileByCode(code: string) {
    return this.http.get(`${this.environmentService.apiUrl}/profiles?code=${code}`).pipe(
      map((profiles: Profile[]) => {
        return profiles[0];
      })
    );
  }
}
